import { axiosInstance } from '@/plugins/axios'

export default {
  namespaced: true,
  state: {
    user: {},
    users: [],
    usersLoading: false
  },
  mutations: {
    setUsersLoading (state, { status }) {
      state.usersLoading = status
    },
    setUsers (state, { users }) {
      state.users = users
    }
  },
  actions: {
    async searchUsers ({ commit }, { user }) {
      commit('setUsersLoading', { status: true })
      const { data } = await axiosInstance.get('/users')

      const users = data?.data
      const formattedUsers = users.map(user => {
        return {
          ...user,
          name: `${user.first_name} ${user.last_name}`,
          sub_vendor: { name: user.sub_vendor_name },
          role: { name: user.role }
        }})

      commit('setUsers', { users: formattedUsers })
      commit('setUsersLoading', { status: false })
    }
  }
}
